/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Description_IntroInputs */

const en_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the character and line position of all`)
};

const fr_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour la position des caracteres et des lignes de tous les`)
};

const de_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere die Zeichen- und Zeilenposition aller`)
};

const it_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna la posizione del carattere e della riga di tutti`)
};

const ru_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновите символ и позицию строки для всех`)
};

const es_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar el carácter y la posición de línea de todos`)
};

const zh_cn2_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新所有字符和行的位置`)
};

const ja_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての文字と行の位置を更新します`)
};

const hi_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी वर्णों और पंक्ति की स्थिति को अपडेट करें`)
};

const pt_pt2_position_modal_description_intro = /** @type {(inputs: Position_Modal_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize a posição dos caracteres e das linhas de todos os itens.`)
};

/**
* | output |
* | --- |
* | "Update the character and line position of all" |
*
* @param {Position_Modal_Description_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_description_intro = /** @type {((inputs?: Position_Modal_Description_IntroInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Description_IntroInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_description_intro(inputs)
	if (locale === "de") return de_position_modal_description_intro(inputs)
	if (locale === "it") return it_position_modal_description_intro(inputs)
	if (locale === "ru") return ru_position_modal_description_intro(inputs)
	if (locale === "es") return es_position_modal_description_intro(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_description_intro(inputs)
	if (locale === "ja") return ja_position_modal_description_intro(inputs)
	if (locale === "hi") return hi_position_modal_description_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_description_intro(inputs)
	return en_position_modal_description_intro(inputs)
});